module.exports = __webpack_public_path__ + "static/intro-high-be85188df73711b64e1b0ad5535b11ed.jpg";